import { Alert, AlertsPaginated, Recipient, Rule } from "./Alert";
import AlertRepository from "./AlertRepository";

interface AlertParams {
  name?: string | null;
  enable?: boolean | null;
  page: number;
  size?: number;
}

interface AlertResponseItem {
  name: string;
  createdAt: string;
  createdBy: string;
  enable: boolean;
  alertId: number;
}

export default class AlertService {
  private readonly alertRepository: AlertRepository;

  constructor() {
    this.alertRepository = new AlertRepository();
  }

  async createAlert(alert: Alert): Promise<any> {
    return this.alertRepository.postAlert(alert);
  }

  async updateAlert(alertId: number, alert: Alert): Promise<any> {
    return this.alertRepository.postUpadateAlert(alertId, alert);
  }

  

  async getAlerts({
    name = null,
    enable = null,
    page = 1,
    size = 20,
  }: AlertParams): Promise<AlertsPaginated> {
    const response = await this.alertRepository.getAlerts({
      name,
      enable,
      page,
      size,
    });

    return {
      totalRecords: response.totalRecords,
      alerts: response.data.map((item: AlertResponseItem) => ({
        alertId: item.alertId,
        alertName: item.name,
        alertCreatedAt: item.createdAt,
        alertCreatedBy: item.createdBy,
        alertEnable: item.enable,
      })),
    };
  }

  async deleteAlert(alertId: number): Promise<void> {
    return this.alertRepository.deleteAlert(alertId);
  }

  async getAlertById(alertId: number): Promise<Alert> {
    const response = await this.alertRepository.getAlertById(alertId);
    
    return {
      ...response,
      alertWhenFiring: JSON.parse(response.alertWhenFiring),
      rules: response.rulesDTO.map((rule: Rule) => rule),
      recipients: response.recipientsDTO.map((recipient: {
        userId: string;
        enableSendEmail: boolean;
        enableSendSms: boolean;
        recipientsId: number;
        userNames: string;
        userMail: string;
      }) => ({
        userId: recipient.userId,
        enableSendEmail: recipient.enableSendEmail,
        enableSendSms: recipient.enableSendSms,
        recipientId: recipient.recipientsId,
        name: recipient.userNames,
        email: recipient.userMail,
      })),
    };
  }
}
